import * as React from 'react';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

export default function BasicModal({ open, onClose, ChildrenContent ,widthSpecial}) {
  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', 
        justifyContent: 'center', alignItems: 'center' ,
        
        }}
    >
      <Paper
        variant="outlined"
        sx={{ 
          width: { xs: '95%', sm: '90%', md: '85%', lg: '80%', xl: widthSpecial == null ? '50%' : widthSpecial },
          margin: { xs: '20px', sm: '20px', md: '10px', lg: '0px', xl: '0px' },
          borderRadius: 3, 
          p: 2, 
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)', 
          position: 'relative',
          maxHeight: '90vh',
          overflow: 'hidden'
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 10, right: 8 }}
        >
         <FontAwesomeIcon icon={faCircleXmark} />
        </IconButton>
        <Box sx={{ p: 1.5, mt: 3 }}>
          {ChildrenContent}
        </Box>
      </Paper>
    </Modal>
  );
}
